import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { AppShell } from '@/app/layout/AppShell';
import { ShellProvider } from '@/app/layout/ShellContext';
import { CompanyProvider } from '@/features/company/CompanyContext';

/** `AppShell`'s top slot for every area reached off the main sidebar rather
 * than being one of its own sections. */
function BackToAppLink() {
  const { t } = useTranslation();
  return (
    <Link
      to="/"
      className="text-ink hover:bg-mint-tint rounded-pill flex h-9 items-center gap-2 px-3 text-sm"
    >
      <ArrowLeft className="size-4 shrink-0" aria-hidden="true" />
      {t('manage.backToApp')}
    </Link>
  );
}

/**
 * The shell for Beheer, Profiel and Instellingen (§ Beheer, § Profiel, §
 * Instellingen): `AppShell` — the exact same one the normal app uses — with
 * a "Terug naar de app" top slot instead of the company switcher, and the
 * caller's own nav (`ManageNav`, `ProfileNav`, `SettingsNav`). One left-hand
 * nav column, structurally identical to the main sidebar, not a second nav
 * mounted next to it.
 */
export function SecondaryShell({ nav }: { nav: (onNavigate?: () => void) => ReactNode }) {
  return (
    <CompanyProvider>
      <ShellProvider>
        <AppShell topSlot={<BackToAppLink />} renderNav={nav} />
      </ShellProvider>
    </CompanyProvider>
  );
}
